export default {
  // 標題
  transactionOverview: "交易概況",
  assetDistribution: "資產分佈",

  // 工具提示
  unitTooltip: "單位：右側選中的幣種",

  // 幣種選擇
  selectCurrency: "請選擇幣種",

  // 統計標籤
  addressBalance: "地址餘額",
  cumulativeInflowOutflow: "累計轉入&轉出數量",
  averageInflowOutflow: "平均轉入&轉出數量",
  inflowOutflowCount: "轉入&轉出筆數",
  inflowOutflowOpponents: "轉入&轉出對手數",

  // 空狀態
  noData: "暫無數據",

  // 圖表系列名稱
  assetDistributionSeries: "資產分佈",
};
